module.exports = __webpack_public_path__ + "static/9-2a2fcc38337df879c9b3f56c57611f79.jpg";